import styled, { css } from 'styled-components'

import { statisticOrientations } from './constants'
import { getBackgroundColor, getBodyOffset, getBorderShadow, getDataGap, getGap, getPadding } from './helpers'

const isHorizontal = props => props.orientation === statisticOrientations.horizontal

export const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: ${props => (isHorizontal(props) ? 'center' : 'flex-start')};
  gap: ${props => getGap(props.size, props.theme)};
  padding: ${props => getPadding(props.orientation, props.size, props.theme)};
  border-radius: ${props =>
    props.isOutlined ? props.theme.primitives.radius.radius1 : props.theme.primitives.radius.radius0};
  background-color: ${getBackgroundColor};
  box-shadow: ${getBorderShadow};
  outline: none;

  ${props =>
    props.isClickable &&
    css`
      cursor: pointer;

      &:hover::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        background-color: ${props.theme.colors.overlay.hover};
        pointer-events: none;
      }

      &:focus-visible {
        outline: ${props.theme.stroke.emphasis} solid ${props.theme.colors.focus};
        outline-offset: ${
          props.isOutlined ? props.theme.primitives.stroke.stroke0 : `calc(-1 * ${props.theme.stroke.emphasis})`
        };
      }
    `}
`

export const IconContainer = styled.div`
  display: flex;
  flex-shrink: 0;
`

export const Body = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: ${props => (isHorizontal(props) ? 'row' : 'column')};
  align-items: ${props => (isHorizontal(props) ? 'center' : 'flex-start')};
  gap: ${props => getGap(props.size, props.theme)};
  padding-top: ${props => getBodyOffset(props.orientation, props.size, props.theme)};
`

export const Label = styled.div`
  flex: ${props => (isHorizontal(props) ? 1 : 'initial')};
  min-width: 0;
`

export const Data = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: ${props => (isHorizontal(props) ? 'flex-end' : 'flex-start')};
  gap: ${props => getDataGap(props.orientation, props.size, props.theme)};
  text-align: ${props => (isHorizontal(props) ? 'right' : 'left')};
`

export const Value = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const Figure = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${props => props.theme.spacing.sp4};
`
